const CONFIG = {
    SERVER : '/ws'
};
export default CONFIG;